<template>
  <div class="paso-config">

    <!-- Proveedor -->
    <div class="config-section">
      <div class="section-label">
        <v-icon small color="primary" class="mr-1">mdi-truck-outline</v-icon>
        Proveedor <span class="req-star">*</span>
      </div>
      <v-form ref="form">
        <div class="proveedor-row">
          <v-autocomplete
            v-model="proveedorId"
            :items="proveedores"
            item-text="nombre"
            item-value="id"
            placeholder="Buscar proveedor..."
            outlined
            dense
            hide-details="auto"
            :loading="loadingProveedores"
            clearable
            no-data-text="No se encontraron proveedores"
          />
          <v-btn small outlined color="primary" class="ml-2 flex-shrink-0" height="40" @click="modalProveedor = true">
            <v-icon left small>mdi-plus</v-icon>
            Nuevo
          </v-btn>
        </div>
      </v-form>
    </div>

    <!-- Tipo de archivo -->
    <div class="config-section mt-6">
      <div class="section-label mb-3">
        <v-icon small color="primary" class="mr-1">mdi-table-cog</v-icon>
        Tipo de archivo <span class="req-star">*</span>
      </div>
      <div class="mode-cards">

        <div
          class="mode-card"
          :class="{ 'mode-card--selected': modo === 'SIMPLE' }"
          @click="modo = 'SIMPLE'"
        >
          <div class="mode-card__header">
            <div class="mode-card__radio" :class="{ 'mode-card__radio--on': modo === 'SIMPLE' }">
              <div v-if="modo === 'SIMPLE'" class="mode-card__radio-inner"></div>
            </div>
            <v-icon class="mode-card__icon" :color="modo === 'SIMPLE' ? 'primary' : 'grey darken-1'">
              mdi-table-row
            </v-icon>
            <span class="mode-card__title">Simple</span>
          </div>
          <p class="mode-card__desc">
            Columnas básicas: código de proveedor, nombre, precio de compra y descuento.
          </p>
          <div class="mode-card__cols">
            <span class="col-tag">codigo_proveedor</span>
            <span class="col-tag">nombre</span>
            <span class="col-tag">precio_compra</span>
            <span class="col-tag">descuento</span>
          </div>
        </div>

        <div
          class="mode-card"
          :class="{ 'mode-card--selected': modo === 'ESTRUCTURADO' }"
          @click="modo = 'ESTRUCTURADO'"
        >
          <div class="mode-card__header">
            <div class="mode-card__radio" :class="{ 'mode-card__radio--on': modo === 'ESTRUCTURADO' }">
              <div v-if="modo === 'ESTRUCTURADO'" class="mode-card__radio-inner"></div>
            </div>
            <v-icon class="mode-card__icon" :color="modo === 'ESTRUCTURADO' ? 'primary' : 'grey darken-1'">
              mdi-table-multiple
            </v-icon>
            <span class="mode-card__title">Estructurado</span>
          </div>
          <p class="mode-card__desc">
            Columnas separadas para marca, modelo y tamaño. Mayor precisión en la coincidencia.
          </p>
          <div class="mode-card__cols">
            <span class="col-tag">marca</span>
            <span class="col-tag">modelo</span>
            <span class="col-tag">tamaño</span>
            <span class="col-tag">precio_compra</span>
          </div>
        </div>

      </div>
    </div>

    <!-- Plantillas -->
    <div class="config-section mt-5">
      <div class="section-label-secondary mb-2">
        <v-icon x-small color="grey darken-1" class="mr-1">mdi-download-outline</v-icon>
        Descargar plantilla de ejemplo
      </div>
      <div class="templates-row">
        <button class="template-btn" @click="descargarPlantillaSimple">
          <v-icon x-small color="green darken-2" class="mr-1">mdi-microsoft-excel</v-icon>
          Plantilla Simple
        </button>
        <button class="template-btn" @click="descargarPlantillaEstructurada">
          <v-icon x-small color="green darken-2" class="mr-1">mdi-microsoft-excel</v-icon>
          Plantilla Estructurada
        </button>
      </div>
    </div>

    <nuevo-proveedor-modal v-model="modalProveedor" @created="onProveedorCreado" />
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import ProveedorProvider from "../../../proveedor/providers/ProveedorProvider";
import NuevoProveedorModal from "../../../importar-productos/pages/ImportarProductosPage/NuevoProveedorModal.vue";

const PLANTILLA_SIMPLE = [
  { codigo_proveedor: "PROV-001", nombre: "Coca Cola 500ml Lata", precio_compra: 85.5, descuento_proveedor: 5 },
  { codigo_proveedor: "PROV-002", nombre: "Ejemplo producto 2",   precio_compra: 45.0, descuento_proveedor: 0 },
];

const PLANTILLA_ESTRUCTURADA = [
  { codigo_proveedor: "PROV-001", marca: "Coca Cola", modelo: "Lata",      "tamaño": "500ml", otras_caracteristicas: "", precio_compra: 85.5, descuento_proveedor: 5 },
  { codigo_proveedor: "PROV-002", marca: "Ejemplo",   modelo: "Modelo X",  "tamaño": "1L",    otras_caracteristicas: "", precio_compra: 45.0, descuento_proveedor: 0 },
];

export default {
  name: "ImportarListaPreciosPasoConfiguracion",
  components: { NuevoProveedorModal },
  data() {
    return {
      valid: false,
      proveedorId: null,
      modo: "SIMPLE",
      proveedores: [],
      loadingProveedores: false,
      modalProveedor: false,
    };
  },
  watch: {
    proveedorId(v) { this.$emit("proveedor-change", v); },
  },
  mounted() {
    this.cargarProveedores();
  },
  methods: {
    async cargarProveedores() {
      this.loadingProveedores = true;
      try {
        const res = await ProveedorProvider.paginateProveedores(1, 500);
        const data = res?.data?.proveedorPaginate;
        this.proveedores = data?.items || [];
      } catch (e) {
        this.$emit("error", e.message || "Error al cargar proveedores");
      } finally {
        this.loadingProveedores = false;
      }
    },
    validate() {
      return true;
    },
    getData() {
      return { proveedorId: this.proveedorId, modo: this.modo };
    },
    descargarPlantillaSimple() {
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(PLANTILLA_SIMPLE), "ListaPrecios");
      XLSX.writeFile(wb, "Plantilla Simple.xlsx");
    },
    descargarPlantillaEstructurada() {
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(PLANTILLA_ESTRUCTURADA), "ListaPrecios");
      XLSX.writeFile(wb, "Plantilla Estructurada.xlsx");
    },
    onProveedorCreado(proveedor) {
      this.proveedores = [...this.proveedores, proveedor];
      this.proveedorId = proveedor.id;
    },
  },
};
</script>

<style scoped>
.paso-config {
  max-width: 680px;
}

/* Section */
.config-section { }
.section-label {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: #3C4043;
  margin-bottom: 10px;
}
.req-star { color: #E53935; margin-left: 2px; }
.opt-label { color: #757575; font-weight: 400; margin-left: 4px; font-size: 12px; }
.proveedor-hint { font-size: 12px; color: #757575; }
.section-label-secondary {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #757575;
}

/* Proveedor row */
.proveedor-row {
  display: flex;
  align-items: flex-start;
  max-width: 520px;
}

/* Mode cards */
.mode-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  max-width: 640px;
}
.mode-card {
  border: 2px solid #E8EAED;
  border-radius: 10px;
  padding: 14px 16px;
  cursor: pointer;
  background: #FAFAFA;
  transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
  user-select: none;
}
.mode-card:hover {
  border-color: #BBDEFB;
  background: #F8FBFF;
}
.mode-card--selected {
  border-color: #1976D2;
  background: #F0F7FF;
  box-shadow: 0 0 0 3px rgba(25,118,210,0.10);
}
.mode-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.mode-card__radio {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #BDBDBD;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.18s;
}
.mode-card__radio--on { border-color: #1976D2; }
.mode-card__radio-inner {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1976D2;
}
.mode-card__icon { flex-shrink: 0; }
.mode-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #202124;
}
.mode-card--selected .mode-card__title { color: #1565C0; }
.mode-card__desc {
  font-size: 12.5px;
  color: #5F6368;
  margin: 0 0 10px;
  line-height: 1.5;
}
.mode-card__cols {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.col-tag {
  font-family: monospace;
  font-size: 10.5px;
  padding: 2px 6px;
  border-radius: 3px;
  background: #F1F3F4;
  color: #5F6368;
  border: 1px solid #E8EAED;
}
.mode-card--selected .col-tag {
  background: #E3F2FD;
  color: #1565C0;
  border-color: #BBDEFB;
}

/* Templates */
.templates-row {
  display: flex;
  gap: 8px;
}
.template-btn {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  font-size: 12px;
  color: #5F6368;
  background: #FAFAFA;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.template-btn:hover {
  background: #F1F3F4;
  border-color: #BDBDBD;
}
</style>
